import { Building2 } from "lucide-react"

import { Card, CardContent } from "@/components/ui/card"
import { TENANT_CLOSED_PUBLIC_MESSAGE } from "@/lib/tenant-closed"

// Lien public ou portail d'un organisme fermé.
// Même texte partout ; jamais « administrateur ».

export function TenantClosedNotice() {
  return (
    <Card className="mx-auto max-w-2xl" data-test="tenant-closed-notice">
      <CardContent className="space-y-3 py-10 text-center">
        <Building2 className="mx-auto size-10 text-muted-foreground" aria-hidden="true" />
        <h2 className="text-xl font-semibold">Service indisponible</h2>
        <p className="text-sm text-muted-foreground">{TENANT_CLOSED_PUBLIC_MESSAGE}</p>
      </CardContent>
    </Card>
  )
}
